// BD: páginas de amostra em fila horizontal; clicar abre a página em grande (visor carregado à parte).
import { useTranslation, type Lang } from "@ecliptica/i18n";
import { Button } from "@ecliptica/ui";
import { lazy, Suspense } from "react";
import { DOWNLOADS } from "../../content/site";
import { Section } from "./Section";

const ComicViewer = lazy(() => import("./ComicViewer"));

export function ComicSection({ lang }: { lang: Lang }) {
  const { t } = useTranslation();
  return (
    <Section id="comic" title={t("comic.title")} lead={t("comic.lead")}>
      <p className="text-center font-title text-gold">{t("comic.ch1")}</p>
      <Suspense>
        <ComicViewer lang={lang} />
      </Suspense>
      <div className="mt-6 text-center">
        <Button asChild variant="primary">
          <a href={DOWNLOADS[lang].comicPdf} download>
            {t("comic.read")}
          </a>
        </Button>
      </div>
    </Section>
  );
}
